export default "__VITE_ASSET__BN9SA4cq__"